import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import useDefaultMarketingFooterPreview from '../hooks/useDefaultMarketingFooterPreview';
import MarketingTemplatesCreate from './create';
import MarketingTemplatesList from './contents/MarketingTemplatesList';
import { isMarketingTemplatesNewSelectorPath } from './marketingTemplatesPaths';

const TemplatesContent = memo(({ onOpenHtmlEditor, onOpenVisualEditor }) => {
    const { pathname } = useLocation();
    const footerPreview = useDefaultMarketingFooterPreview(true);

    let body;
    if (isMarketingTemplatesNewSelectorPath(pathname)) {
        body = (
            <MarketingTemplatesCreate
                footerPreview={footerPreview}
                onOpenHtmlEditor={onOpenHtmlEditor}
                onOpenVisualEditor={onOpenVisualEditor}
            />
        );
    } else {
        body = (
            <MarketingTemplatesList
                footerPreview={footerPreview}
                onOpenHtmlEditor={onOpenHtmlEditor}
                onOpenVisualEditor={onOpenVisualEditor}
            />
        );
    }

    return <div className="marketing-templates__wrapper">{body}</div>;
});

TemplatesContent.displayName = 'TemplatesContent';

TemplatesContent.propTypes = {
    onOpenHtmlEditor: PropTypes.func,
    onOpenVisualEditor: PropTypes.func,
};

export default TemplatesContent;
